/*
 * File: AuthenticatedRoute.js
 * Project: patient-portal
 *
 * Created by Nate Weber on 08/14/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Route that can only be accessed by an authenticated
 * user. Redirects to login page if not authenticated.
 */

import React from "react";
import PropTypes from "prop-types";
import { Redirect, Route } from "react-router-dom";

import { useAppStore } from "stores/AppStore";

const AuthenticatedRoute = ({ component: Component }, { ...rest }) => {
  const app = useAppStore();

  return (
    <Route
      {...rest}
      render={({ location, ...props }) =>
        app.auth.isAuthenticated() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location }
            }}
          />
        )
      }
    />
  );
};

AuthenticatedRoute.propTypes = {
  component: PropTypes.elementType
};

export default AuthenticatedRoute;
